<template>
	<div>
		<el-form ref="searchForm" :model="searchForm"  label-width="110px" label-position="right" v-if="isAdd" style="margin-top: 2rem;">
			<el-row class="row-content">
				<el-col :span="10">
					<el-form-item label="姓名:" prop="name">
						<el-input v-model="searchForm.name" placeholder="请输入姓名" />
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="证书编号:" prop="certificateNum">
						<el-input v-model="searchForm.certificateNum" placeholder="请输入证书编号" />
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" size="small" @click="getList">检索</el-button>
					<el-button type="warning" size="small" @click="toAdd">新增</el-button>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="content" v-if="isAdd">
			<el-table v-loading="loading" :data="list" tooltip-effect="light">
				<el-table-column label="姓名" align="center" prop="name" :show-overflow-tooltip="true"/>
				<el-table-column label="性别" align="center" prop="sex" :formatter="sexsFormat"/>
				<el-table-column label="年龄" align="center" prop="age" />
				<el-table-column label="证书编号" align="center" prop="certificateNum" :show-overflow-tooltip="true" :width="100"/>
				<el-table-column label="发证机构" align="center" prop="issuingAuthority" :show-overflow-tooltip="true"/>
                <el-table-column label="行业" align="center" prop="industry" />
                <el-table-column label="职务/职称" align="center" prop="post" />
				<el-table-column label="手机" align="center" prop="iphone" width="120"/>
				<el-table-column label="区域" align="center" prop="region" :show-overflow-tooltip="true"/>
				<el-table-column label="操作" align="center" :show-overflow-tooltip="true" prop="recid" width="100"> 
                    <template slot-scope="scope">
						<el-button size="mini" type="text" @click="toEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getList" />
		</el-row>

		<!--新增修改-->
		<el-form ref="form" :model="form" :rules="rules" label-width="110px" label-position="right" v-if="!isAdd" style="margin-top: 2rem;">
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="姓名:" prop="name">
						<el-input v-model="form.name" placeholder="请输入姓名" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12" style="text-align: left;">
					<el-form-item label="性别:" prop="sex">
						<el-radio-group v-model="form.sex">
						<el-radio  label="0">男</el-radio>
						<el-radio label="1">女</el-radio>
						</el-radio-group>
						<!--<el-radio-group v-model="form.sex">
							<el-radio v-for="dict in sexs" :key="dict.dictValue" :label="dict.dictValue">
								{{dict.dictLabel}}
							</el-radio>
						</el-radio-group>-->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="年龄:" prop="age">
						<el-input v-model="form.age" placeholder="请输入年龄" type="number"/>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="证书编号:" prop="certificateNum">
						<el-input v-model="form.certificateNum" placeholder="请输入证书编号" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="发证机构:" prop="issuingAuthority">
						<el-input v-model="form.issuingAuthority" placeholder="请输入发证机构" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="行业:" prop="industry">
						<el-input v-model="form.industry" placeholder="请输入行业" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12" style="text-align: left;">
					<el-form-item label="所在单位:" prop="unit">
						<span>{{form.unit}}</span>	
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="职务/职称:" prop="office">
						<el-input v-model="form.office" placeholder="请输入职务/职称" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="手机号:" prop="iphone">
						<el-input v-model="form.iphone" placeholder="请输入手机号" type="number"/>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item label="所属区县" prop="region">
						<el-select v-model="form.region" size="medium" clearable>
						  <el-option
						    v-for="item in orgcodeOptions"
						    :key="item.deptCode"
						    :label="item.shortName"
						    :value="item.deptCode">
						  </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content">
				<el-col :span="12">
					<el-form-item>
<!--						<el-button type="primary" size="small" @click="save()">保存</el-button>-->
						<el-button type="warning" size="small" @click="submit()">提交</el-button>
						<el-button type="primary" size="small" @click="toBack()">返回</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import {
		getListDept
	} from "@/api/system/dept"
	import { listZlg, getZlg, delZlg, addZlg, updateZlg } from "@/api/zlts/zlppfw/zlg";

	export default {
		name: 'qygzsZlg',
		data() {
			return {
				searchForm: {
					pageNum: 1,
					pageSize: 10,
					name: undefined,
					certificateNum: undefined,
					ywFwjgRecid:undefined,
				},
				// 表单校验
			/*	searchRules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					certificateNum: [{
						required: true,
						message: '请输入证书编号',
						trigger: 'blur'
					}],
				},*/
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				isAdd:true,
				form:{
					name: undefined,
					sex: '0',
					age: undefined,
					certificateNum: undefined,
					issuingAuthority: undefined,
					industry: undefined,
					post: undefined,
					iphone: undefined,
					region: undefined,
					shType: undefined,
					unit:undefined,
					ywFwjgRecid:undefined,
				},
				rules:{
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					certificateNum: [{
						required: true,
						message: '请输入证书编号',
						trigger: 'blur'
					}],
				},
				orgcodeOptions:[],
				deptQueryParams:{
					deptLevel:'3',
					deptType:'1'
				},
				sexs: [],
			}
		},
		created() {
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			if(this.loginUser != null && this.loginUser != undefined){
				this.searchForm.ywFwjgRecid = this.loginUser.ywFwjgRecid;
				this.form.ywFwjgRecid = this.loginUser.ywFwjgRecid;
				this.form.unit = this.loginUser.corname;
				this.form.region = this.loginUser.county;
			}
			this.getDicts("sys_user_sex").then(response => {
				this.sexs = response.data;
			});
			this.getList();
			this.getdeptlist();
		},
		methods: {
			sexsFormat(row, column) {
				return this.selectDictLabel(this.sexs, row.sex);
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getList() {
				this.loading = true;
				listZlg(this.searchForm).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
				/*
				this.loading = true;
				let that = this;
				setTimeout(function() {
					that.loading = false;
					if (that.queryParams.pageNum == 1) {
						that.list = [{
								recid: '1',
								name: '姜忠文',
								sex: '男',
								age: '52',
								certNum: 'SDHL/CQO/011-055',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '轻工',
								office: '质量负责人',
								tel: '13863069570',
								region: '经区',
							},
							{
								recid: '2',
								name: '林玉华',
								sex: '女',
								age: '52',
								certNum: 'SDHL/CQO/021-055',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '食品制造',
								office: '部长',
								tel: '13563103498',
								region: '经区',
							}, {
								recid: '3',
								name: '王敬',
								sex: '女',
								age: '47',
								certNum: 'SDHL/CQO/023-009',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '机械',
								office: '质量经理',
								tel: '13906310846',
								region: '经区',
							}, {
								recid: '4',
								name: '姚明凯',
								sex: '男',
								age: '37',
								certNum: 'SDHL/CQO/023-010',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '电子',
								office: '质量科长',
								tel: '13406746955',
								region: '经区',
							}, {
								recid: '5',
								name: '宫晓春',
								sex: '女',
								age: '37',
								certNum: 'SDHL/CQO/023-012',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '化工',
								office: '质量工程师',
								tel: '18663122101',
								region: '经区',
							}, {
								recid: '6',
								name: '郑晓辉',
								sex: '女',
								age: '51',
								certNum: 'SDHL/CQO/028-026',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '食品制造',
								office: '质检部经理',
								tel: '13406311136',
								region: '经区',
							}, {
								recid: '7',
								name: '焦玉',
								sex: '男',
								age: '54',
								certNum: 'SDHL/CQO/028-027',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '机械',
								office: '部门经理',
								tel: '13656301233',
								region: '经区',
							}, {
								recid: '8',
								name: '刘鑫',
								sex: '男',
								age: '37',
								certNum: 'SDHL/CQO/028-028',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '制造业',
								office: '质管部副部长',
								tel: '13371172707',
								region: '经区',
							}, {
								recid: '9',
								name: '刘丽丽',
								sex: '女',
								age: '45',
								certNum: 'SDHL/CQO/028-033',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '制造业',
								office: '主任',
								tel: '13562165978',
								region: '经区',
							}, {
								recid: '10',
								name: '丛亭滋',
								sex: '男',
								age: '39',
								certNum: 'SDHL/CQO/028-039',
								issueOrg: '山东华鲁管理咨询培训中心',
								industry: '电子',
								office: 'IPQA Manager',
								tel: '18669391297',
								region: '经区',
							},
						];

					} else {
						that.list = [{
							recid: '11',
							name: '隋文超',
							sex: '男',
							age: '36',
							certNum: 'SDHL/CQO/028-040',
							issueOrg: '山东华鲁管理咨询培训中心',
							industry: '制造',
							office: '经理',
							tel: '13356819699',
							region: '经区',
						}, ];
					}
					that.total = 11;
				}, 500);
				*/
			},
			toAdd(){
				this.isAdd = !this.isAdd;
			},
			getdeptlist(){
				getListDept(this.deptQueryParams).then(res => {
					this.orgcodeOptions = res.data;
				})
			},
			toEdit(row){
				this.isAdd = !this.isAdd;
				this.form = row;
				/* 这些到时候按实际情况来 */
				// this.form.unit='威海丽颜化妆品有限公司';
				if (row.sex == '男') {
					this.form.sex = '0'
				} else if (row.sex == '女') {
					this.form.sex = '1'
				}
				/* 这些到时候按实际情况来 */
				const recid = row.recid;
				getZlg(recid).then(response => {
					this.form = response.data;
				});
			},
			resetData(){
				this.form={
					name: undefined,
							sex: '0',
							age: undefined,
							certificateNum: undefined,
							issuingAuthority: undefined,
							industry: undefined,
							post: undefined,
							iphone: undefined,
							region: undefined,
							shType: undefined,
				};
				this.isAdd = !this.isAdd;
			},
			/** 删除按钮操作 */
			handleDelete(row) {
				const recids = row.recid;
				this.$confirm('是否确认删除质量官管理编号为"' + recids + '"的数据项?', "警告", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(function() {
					return delZlg(recids);
				}).then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				}).catch(function() {});
			},
			save(){
				this.isAdd = true;
			},
			toBack(){
				//this.isAdd = !this.isAdd;
				this.resetData();
			},
			submit(){
				this.$refs["form"].validate(valid => {
					if(valid){
						this.$confirm('是否确认保存当前信息？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							if (this.form.recid != undefined) {
								this.form.shType = 1;
								updateZlg(this.form).then(response => {
									if (response.code === 200) {
										this.msgSuccess("修改成功");
										this.resetData();
										this.getList();
									} else {
										this.msgError(response.msg);
									}
								});
							} else {
								addZlg(this.form).then(response => {
									if (response.code === 200) {
										this.msgSuccess("新增成功");
										this.resetData();
										this.getList();
									} else {
										this.msgError(response.msg);
									}
								});
							}
						})
					}
				})

			}
		}
	}
</script>

<style scoped="scoped">
	.el-select{
		width: 21.25rem;
	}
</style>
